.ej{color:var(--gray-700);}